import Api from '@/assets/js/api.js';

export const ProductsService = {
    async get(params) {
        try {
            const response = await Api.get('/theme/v1/products/get/', {
                params: params
            });

            return response.data;
        } catch (error) {
            console.error(error);
            return error;
        }
    }
};

export default ProductsService;
